// extracted by mini-css-extract-plugin
export var medium = "Button-medium-YynWp";
export var primary = "Button-primary-jsFsI";
export var root = "Button-root-eGKyH";
export var secondary = "Button-secondary-2kXjD";